const SB = import.meta.env.VITE_SUPABASE_URL;
const ANON = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!SB || !ANON) {
  console.error(
    "Missing VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY. Copy .env.example to .env and fill them in."
  );
}

const TOKEN_KEY = "vfa_token";

export function getToken() {
  return sessionStorage.getItem(TOKEN_KEY);
}
export function setToken(t) {
  sessionStorage.setItem(TOKEN_KEY, t);
}
export function clearToken() {
  sessionStorage.removeItem(TOKEN_KEY);
}

/** Sign in with email + password. Returns { access_token } or { error_description }. */
export async function signIn(email, password) {
  const res = await fetch(`${SB}/auth/v1/token?grant_type=password`, {
    method: "POST",
    headers: { "Content-Type": "application/json", apikey: ANON },
    body: JSON.stringify({ email, password }),
  });
  return res.json();
}

/**
 * Call a Supabase Edge Function.
 * Every vfa-* function decodes the JWT itself, so verify_jwt is false on all of
 * them and the apikey header is still required by the gateway.
 */
export async function edge(fn, { method = "GET", body = null, token } = {}) {
  const opts = {
    method,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token ?? getToken()}`,
      apikey: ANON,
    },
  };
  if (body) opts.body = JSON.stringify(body);
  const res = await fetch(`${SB}/functions/v1/${fn}`, opts);
  return res.json();
}

export const api = {
  commandCenter: (token) => edge("vfa-command-center", { token }),
  runRadar: (token) => edge("vfa-prospect-radar", { method: "POST", body: {}, token }),
  draftEmail: (token, companyId, contactId) =>
    edge("vfa-outreach", {
      method: "POST",
      token,
      body: {
        company_id: companyId,
        contact_id: contactId,
        action_type: "outreach",
        mode: "draft",
      },
    }),
  buildPitch: (token, companyId, regenerate = false) =>
    edge("vfa-pitch", {
      method: "POST",
      token,
      body: { company_id: companyId, regenerate },
    }),
  onboard: (token, payload) =>
    edge("vfa-onboarding", { method: "POST", body: payload, token }),
};
